<template>
    <div class="d-flex flex-wrap" :alvqa="alvqa + '-outcome-counts'">
        <v-chip
            v-for="outcome in shown"
            :key="outcome.value"
            small
            label
            outlined
            class="mr-2 mb-2"
            :color="outcome.color"
            :input-value="active === outcome.value"
            :link="clickable"
            :alvqa="alvqa + '-outcome-count-' + outcome.value"
            @click="clickable && $emit('select', outcome.value)"
        >
            <span class="font-weight-bold mr-1">{{ $n(outcomes[outcome.value] || 0) }}</span>
            <span class="text--primary">{{ $t(outcome.text) }}</span>
        </v-chip>
    </div>
</template>

<script>
import { OUTCOMES } from '../usageOptions'

/** A comparison's findings by outcome, as small chips; clickable on the review page to filter. */
export default {
    name: 'OutcomeCounts',
    props: {
        outcomes: { type: Object, default: () => ({}) },
        clickable: { type: Boolean, default: false },
        active: { type: String, default: null },
        hideEmpty: { type: Boolean, default: false },
        alvqa: { type: String, default: '' }
    },
    computed: {
        shown() {
            return OUTCOMES.filter(o => !this.hideEmpty || (this.outcomes[o.value] || 0) > 0)
        }
    }
}
</script>

